import PropTypes from 'prop-types';
import React from 'react';

import MessageHandler from 'commons-forms/components/MessageHandler/MessageHandler.jsx';

const ErrorsHandler = ({ errors }) => {
    const errorsListing = errors.map((error, index) => {
        const classNames = ['error-section'];

        if (index + 1 === errors.length) {
            classNames.push('last-error');
        }

        return (
            <li key={error.code} className={classNames.join(' ')}>
                {error.message}
            </li>
        );
    });

    return (
        <MessageHandler
            body={<ul className="error-listing">{errorsListing}</ul>}
            code="error"
            canCloseElement
            messageIcon="icon-Warning"
        />
    );
};

ErrorsHandler.defaultProps = {
    errors: [],
};

ErrorsHandler.propTypes = {
    errors: PropTypes.arrayOf(
        PropTypes.shape({
            code: PropTypes.string.isRequired,
            message: PropTypes.string.isRequired,
        })
    ),
};

ErrorsHandler.displayName = 'ErrorsHandler';

export default ErrorsHandler;
